import React from 'react';
import { useQuery, Loading, Error, CheckboxGroupInput , required } from 'react-admin';

const UserCheckField = ({props}) =>{
 
    let users =  [];
    var source = props && props.source? props.source : 'users'
    var label = props && props.label ? props.label : 'Users'

    if(props.record && !props.record.users) { props.record.users = []; }

    const { data, loading, error } = useQuery({ 
        type: 'getList',
        resource: 'usernames',
        payload:  {
            pagination: { page: 1 , perPage: 20 },
            sort: { field: 'name', order: 'ASC' }
        }
    });
 
    if (loading) return <Loading />;
    if (error) return <Error />;
    if (!data) return null;
    users = data;
    console.log(data)
    return (
        <CheckboxGroupInput  source={source}    label={label} choices={users} />
        )
}

export default UserCheckField
